var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./store-controls.j2"] = require( "./store-controls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/store-results.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.memberLookup(((lineno = 1, colno = 25, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["relationships"]))),"stores")),"favoriteStores");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("store", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"storeImages")),0)),"links")),0)),"href")) {
output += "\n\n    <div class=\"o-row c-store-result__inner\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <a class=\"c-store-result__img--a\" href=\"";
output += runtime.suppressValue((lineno = 9, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")])), env.opts.autoescape);
output += "stores/";
output += runtime.suppressValue(runtime.memberLookup((t_4),"slug"), env.opts.autoescape);
output += "\">\n\n               <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"storeImages")),0)),"links")),0)),"href"), env.opts.autoescape);
output += "\" class=\"c-store-result__img\" alt=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"name")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"name"):runtime.memberLookup((t_4),"storeFriendlyName")), env.opts.autoescape);
output += ", ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"city"), env.opts.autoescape);
output += "\" data-qa-your-favorite-store-image/>\n\n            </a>\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n\n<div class=\"o-row c-store-result__inner\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div class=\"c-store-result__wrapper\">\n\n            <div class=\"o-row c-store-result__inner\">\n\n                <div class=\"o-row o-column o-extra-small--12 c-store-result__wrapper--wrap\">\n\n                    ";
env.getTemplate("./store-controls.j2", false, "account/templates/partials/store-results.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n                    <div class=\"o-address-display\">\n\n                        <span class=\"o-address-display__header\" data-qa-favorite-store-name>\n\n                            ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"name")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"name"):runtime.memberLookup((t_4),"storeFriendlyName")), env.opts.autoescape);
output += "\n\n                        </span>\n\n                        <span class=\"o-address-display__line\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"addressLineOne"), env.opts.autoescape);
output += "\n                        </span>\n\n                        <span class=\"o-address-display__line\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"addressLineTwo"), env.opts.autoescape);
output += "\n                        </span>\n\n                        <span class=\"o-address-display__line\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"city"), env.opts.autoescape);
output += ", ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"state"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"zip"), env.opts.autoescape);
output += "\n                        </span>\n\n                        <span class=\"o-address-display__line\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"addresses")),"marketing")),"phoneNumber"), env.opts.autoescape);
output += "\n                        </span>\n\n                        <a href=\"";
output += runtime.suppressValue((lineno = 57, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")])), env.opts.autoescape);
output += "stores/";
output += runtime.suppressValue(runtime.memberLookup((t_4),"slug"), env.opts.autoescape);
output += "\" class=\"c-store-controls__details\" data-qa-favorite-store-details>\n                            ";
output += runtime.suppressValue((lineno = 58, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-detail",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</a>\n\n                        <span class=\"c-store-controls__divider\">&#124;</span>\n\n                        <a href=\"\" class=\"c-store-controls__remove js-account-remove-store-modal-trigger\" data-store-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"storeNumber"), env.opts.autoescape);
output += "\" data-qa-favorite-store-remove>\n                            ";
output += runtime.suppressValue((lineno = 63, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-remove",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</a>\n\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n\n";
})});
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/store-results.j2"] , dependencies)